import React from 'react';
import Chip from '@mui/material/Chip';

type StatusPillProps = {
  children: React.ReactNode;
  tone: 'danger' | 'info' | 'muted' | 'success' | 'warn';
};

export function StatusPill({ children, tone }: StatusPillProps) {
  const colors = {
    danger: { backgroundColor: 'error.light', color: 'error.main' },
    info: { backgroundColor: 'info.light', color: 'info.main' },
    muted: { backgroundColor: '#f0f5f2', color: 'text.secondary' },
    success: { backgroundColor: 'success.light', color: 'success.main' },
    warn: { backgroundColor: 'warning.light', color: 'warning.main' },
  } as const;

  return (
    <Chip
      className={`pill ${tone}`}
      label={children}
      size="small"
      sx={{
        ...colors[tone],
        height: 24,
        '& .MuiChip-label': {
          padding: 0,
        },
      }}
    />
  );
}
